import axios from 'axios';

// Use explicit env override if provided, otherwise rely on same-origin relative path.
// CRA dev server will proxy /api -> backend when a proxy is defined in package.json.
const API_URL = process.env.REACT_APP_API_URL || '/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const needsApproval = error.response?.data?.needsApproval;
    
    // Don't redirect if user needs approval
    if (needsApproval) {
      return Promise.reject(error);
    }
    
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.setItem('sessionExpired', 'true');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
